
define('text!templates/index.html',[],function () { return '<div class="page-head"/>\n<div class="page-box-c layout index-layout">\n\t<div class="page-body">\n\t\t<div class="page-body-c index-content">\n\t\t\t<!--content here -->\n\t\t</div>\n\t</div>\n</div>';});

